import { useKeySettingBool } from '@/hooks/useKeySetting';

/** Cấu hình › Switch Keys: bật chức năng Backup báo cáo (menu Hệ thống › Backup báo cáo). Mặc định tắt → ẩn. */
export const CONFIG_KEY_SU_DUNG_BACKUP_BAO_CAO = 'config_setting_su_dung_backup_bao_cao';

export function useSuDungBackupBaoCao() {
  const { value, loading } = useKeySettingBool(CONFIG_KEY_SU_DUNG_BACKUP_BAO_CAO, false);
  return { enabled: value, loading };
}
